import { getCookie } from 'sutils';
import { browser, isAppLargerOrEqual } from '@src/slide/infrastructure/module/independent/agent/common';
import { isPreview } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';

/**
 * 是否支持原生titleBar
 * 1. 通过客户端写入的cookie判断是否启用新顶部栏
 * 2. 预览态使用drive封装壳子，端内也不兼容处理NativeTitleBar逻辑
 * @returns
 */
let isSupport;
export function isSupportNativeTitleBar() {
    if (isSupport === undefined) {
        const nvTypes = getCookie('nv_types') || '';
        isSupport = nvTypes.indexOf('slide') > -1 && !isPreview();
    }
    return isSupport;
}

export function isSupportCertification() {
    // 关闭2.16.9版本以下的微信公众号认证功能
    return browser.isTencentDocApp ? isAppLargerOrEqual('2.16.9') : true;
}

export function showCertification() {
    return ((window.clientVars?.official_auth_info && !window.clientVars?.userInfo)
    || window.clientVars?.docInfo?.certification?.isCertification);
}

/**
 * 判断编辑状态下是否展示native title.
 * @returns
 */
export function isShowNativeEditTitleBar() {
    return isSupportNativeTitleBar() && !browser.isPad;
}
